/**
 * "Recently opened notes": ids and timestamps only, kept per user in localStorage (like the
 * databases). A convenience, never proof of access: the catalogs show an entry only when the
 * CURRENT note list contains it.
 */
const MAX_RECENT = 30;

interface RecentEntry {
  id: string;
  at: number;
}

const keyFor = (userId: string) => `zadok.recentDocuments.${userId}`;

function read(userId: string): RecentEntry[] {
  try {
    const parsed: unknown = JSON.parse(window.localStorage.getItem(keyFor(userId)) ?? '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (entry): entry is RecentEntry =>
        typeof entry === 'object' &&
        entry !== null &&
        typeof (entry as RecentEntry).id === 'string' &&
        typeof (entry as RecentEntry).at === 'number',
    );
  } catch {
    return [];
  }
}

export function recordRecentDocument(userId: string, documentId: string): void {
  const rest = read(userId).filter((entry) => entry.id !== documentId);
  try {
    window.localStorage.setItem(
      keyFor(userId),
      JSON.stringify([{ id: documentId, at: Date.now() }, ...rest].slice(0, MAX_RECENT)),
    );
  } catch {
    /* storage unavailable: the list just is not remembered */
  }
}

/** Note ids, most recent first. */
export function readRecentDocumentIds(userId: string): string[] {
  return read(userId)
    .sort((a, b) => b.at - a.at)
    .map((entry) => entry.id);
}
